import React from 'react';
import {gql, useQuery} from "@apollo/client/index";

const GET_LOCATION_DATA = gql`
  query($payload: String) {
        getLocationData(payload: $payload) {
            zipCode
            city
            state
        }
  }
`;

export default function LocationDataRequest(props) {

    const { error, data } = useQuery(GET_LOCATION_DATA, {variables: {payload: JSON.stringify({
        lon: props.payload.coords.longitude,
        lat: props.payload.coords.latitude,
        speed: props.payload.coords.speed,
    })}});

    if (error) {
        props.onError(error);
    }

    if (data) {
        props.onData(data.getLocationData);
    }

    return null;
}
